import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'react-emotion';
import Page from 'structure/page';
import ImageViewer from 'components/image-viewer';
import images from './images';
import { IMAGE_THUMBNAIL_CLICK } from 'util/events';

const PositionBox = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  width: '265px',
}, ({ theme }) => ({
  ...theme.media.desktop({
    float: 'right',
    display: 'block',
    marginLeft: '10px',
  })
}));

export const Commission = (props) => (
  <Page title="Commisions" {...props} >
    <PositionBox>
      <ImageViewer
        width="240px"
        height="331px"
        images={images}
        right
        onThumbnailClick={(index) => props.onEvent(IMAGE_THUMBNAIL_CLICK('Comissions', index))}
      >
        Commission for Evolve Photography (<a href="http://www.evolvephotography.com.au">http://www.evolvephotography.com.au</a>).
        <br />Red silk dupioni with black lace decorations.
      </ImageViewer>
    </PositionBox>
    <p>At Creative Corsetry we are comitted to working with you to achieve the look and style that is tailored specifically to meet your needs and wishes</p>
    <p>We strive to create a unique and fun experience when you choose to have a garment crafted by us for your special occasion, including:</p>
    <h3>Weddings</h3>
    <ul>
      <li>bridal,</li>
      <li>bridesmaid,</li>
      <li>mother of the bride,</li>
    </ul>
    <h3>Formal Occasions</h3>
    <ul>
      <li>evening wear,</li>
      <li>historical balls</li>
      <li>formals</li>
      <li>debutante balls</li>
    </ul>
    <h3>Themed Balls and Parties</h3>
    <ul>
      <li>costume conventions</li>
      <li>steam punk</li>
      <li>fantasy</li>
      <li>goth</li>
    </ul>
    <p>Our aim is to work with you to ensure your experience will include:</p>
    <ul>
      <li>individual consultation</li>
      <li>assistance with styles and colour combinations</li>
      <li>high quality materials</li>
      <li>superb craftmanship</li>
    </ul>
    <p>
      <Link to="/about/">Contact us</Link> at <a href="mailto:info@creativecorsetry.com.au">info@creativecorsetry.com.au</a> to discuss your options.
    </p>
  </Page>
);

export default Commission;



// WEBPACK FOOTER //
// ./src/pages/commission/commission.js